/**
 * /skills shell — a thin layout that frames the three sub-views
 * (Standing / Focus / Journey). The page grew too dense as a single scroll,
 * so it's split by mental mode behind a segmented control.
 *
 * SkillDetail (/skills/:skillId) is intentionally NOT under this layout — it's
 * a focused drill-down with its own back button, no tab chrome.
 */

import { Outlet } from "react-router-dom";

import { SkillsTabs } from "@/features/skills/components/SkillsTabs";
import { NavIcons } from "@/shared/components/icons";
import { PageContainer } from "@/shared/components/layout/PageContainer";
import { PageHeader } from "@/shared/components/layout/PageHeader";

export function SkillsLayout() {
  return (
    <PageContainer>
      <PageHeader
        Icon={NavIcons.skills}
        title="Where You're At"
        subtitle="The coach's read on your game, based on every signal it's logged."
      />

      <SkillsTabs />

      <Outlet />
    </PageContainer>
  );
}
